<template>
  <top-nav :pageList="pageList"><slot></slot></top-nav>
</template>

<script>
import topNav from '@/components/topNav'
export default {
  components: {
    topNav
  },
  data() {
    return {
      pageList: []
    }
  },
  created() {
    for (let i in this.$store.state.mainList) {
      if (this.$store.state.mainList[i].id === 7) {
        this.pageList = this.$store.state.mainList[i].children
        break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
